import clsx from "clsx";
import { Fragment } from "react";

const ContentLayouts = ({ children, classNames }) => {
    return (
        <Fragment>
            <div className={clsx(
                "w-full px-0 desktop:px-[103px] mx-auto",
                classNames
            )}>
                {children}
            </div>
        </Fragment>
    );
};

export default ContentLayouts;